/*
 * log
 *
 * Logs messages with a recognizable prefix
 */
const log = (message, variable) => {
  if (variable !== undefined) {
    console.error("You tried to pass a variable to window.log using window.log('My message', variable). Please don't. Use window.log('My message ' + variable) instead."); // eslint-disable-line no-console
  }
  console.log(`%cdev%c ${message}`, 'font-weight: 900; color: #ffffff; background-color: #ff0133', 'color: #000000;'); // eslint-disable-line no-console
};

export default log;
